module.exports = __webpack_public_path__ + "static/media/bdr_cv.f1dabaf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bdr_cv.jpg
// module id = 573
// module chunks = 1